   <!--Main COintainer Starts-->
<div [@routerTransition]>
  <!--User Profile wizard Starts-->
  <div class="row">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form margin-top-14p">
      <div class="card-body nurse-profile-card-body primary-background">
        <div>
          <div id="advanced-form" action="#">
            <!--<h3><span class="s-title"><span class="xs-hide">Personal Info</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Personal Info</legend>

                <personaldetailinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                    [CanEdit]='CanEditProfileInfo' [CanShow]='CanShowProfileInfo'
                                    *ngIf="CurrentActorProfileController.ActorCode >0"></personaldetailinfo>

              </div>
            </fieldset>-->
            <div class="">

            </div>
            <!-- step-1 -->
            <h3><span class="s-title"><span class="xs-hide">Personal Info</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Personal Info</legend>

                <personaldetailinfo [ActorCode]='CurrentActorProfileController.ActorCode'
                                    [CanEdit]='CanEditProfileInfo' [CanShow]='CanShowProfileInfo'
                                    *ngIf="CurrentActorProfileController.ActorCode >0"></personaldetailinfo>

              </div>
            </fieldset>
            <h3><span class="s-title"><span class="xs-hide">Guardian</span> <span class="s-icon"><i class="fas fa-caret-up top-arrow"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Guardian</legend>

                <guardianinfo></guardianinfo>

              </div>
            </fieldset>

            <!-- Step2 -->
            <h3><span class="s-title"><span class="xs-hide">Emergency</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Emergency</legend>
                <emergencyinfo></emergencyinfo>

              </div>
            </fieldset>
            <!-- Step3 -->
            <!-- Step4 -->
            <h3><span class="s-title"><span class="xs-hide">Vitals</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div class="certification-form">
                <legend>Vitals</legend>
                <!--<vitals></vitals>-->
                <!--<actorvitalform></actorvitalform>-->
              </div>
            </fieldset>
            <!-- Step5 -->
            <h3><span class="s-title"><span class="xs-hide">Medical Histroy</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Medical Histroy</legend>
                <medicalfitnessinfov2 [ActorCode]='CurrentActorProfileController.ActorCode'
                                      [CanEdit]='CanEditMedicalFitness' [CanShow]='CanShowMedicalFitness'
                                      *ngIf="CurrentActorProfileController.ActorCode >0"></medicalfitnessinfov2>

                <!--<div class="row">
                  <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
                </div>-->
              </div>
            </fieldset>
            <h3><span class="s-title"><span class="xs-hide">Observations</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Observations</legend>
                <observationsinfov2></observationsinfov2>

                <!--<div class="row">
                  <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
                </div>-->
              </div>
            </fieldset>
            <h3><span class="s-title"><span class="xs-hide">Other Data</span> <span class="s-icon"><i class="fas fa-caret-up"></i></span><span class="t-icon"><i class="fas fa-check-circle"></i></span></span></h3>
            <fieldset class="margin-top-10">
              <div>
                <legend>Other Data</legend>
                <otherdatainfo></otherdatainfo>

              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--User Profile wizardEnd-->
</div>

